import { render } from "@testing-library/react";
import { useEffect, useState } from "react";
import Select from 'react-select';
import { TableBodyClass, getCookies } from "../../services/Utility";
import Api from "../../services/Api";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import PrintForm from "./PrintForm";
import _ from 'lodash';

const ropaName = [
  {
    name: "name",
    placeholder: "Enter message here",
    label: "Message"
  }
]

const contact = [
  {
    name: "first_name",
    placeholder: "Enter name here",
    label: "First Name"
  },
  {
    name: "last_name",
    placeholder: "Enter name here",
    label: "Last Name"
  },

  {
    name: "address",
    placeholder: "Enter address here",
    label: "Address"
  },
  {
    name: "city",
    placeholder: "Enter city name here",
    label: "City"
  },
  // {
  //     name:"state",
  //     placeholder: "Enter state here",
  //     label: "State/Province"
  // },
  {
    name: "zip_code",
    placeholder: "Enter zipcode here",
    label: "Zipcode"
  },
  {
    name: "country",
    placeholder: "Enter country name here",
    label: "Country"
  },
  {
    name: "phone_number",
    placeholder: "Enter phone number here",
    label: "Phone number"
  },
  {
    name: "email_address",
    placeholder: "Enter email address here",
    label: "Email address"
  },
]

const records = [
  {
    name: "status",
    placeholder: "Select status here",
    label: "Status"
  },
  {
    name: "business",
    placeholder: "Select business here",
    label: "Business function"
  },
  {
    name: "purpose",
    placeholder: "Select purpose here",
    label: "Purpose of processing"
  },
  {
    name: "role",
    placeholder: "Select role here",
    label: "R2's role"
  },
  {
    name: "categoryIndividual",
    placeholder: "Select category of Individual here",
    label: "Category of Individual"
  },
  {
    name: "categoryPersonal",
    placeholder: "Select category of personal here",
    label: "Category of personal data"
  },
  {
    name: "lawful",
    placeholder: "Select lawful basis here",
    label: "Lawful basis"
  },
  {
    name: "InternationalDataTransfer",
    placeholder: "Select International data transfer here",
    label: "International data transfer"
  },
  {
    name: "InternationalTransferSafeguards",
    placeholder: "Select International transfer safeguards here",
    label: "International transfer safeguards"
  },
  {
    name: "ExternalRecipients",
    placeholder: "Select External recipients with access here",
    label: "External recipients with access"
  },
  {
    name: "RetentionSchedule",
    placeholder: "Select Retention schedule defined here",
    label: "Retention schedule defined"
  },
  {
    name: "securityMeasures",
    placeholder: "Select Technical & organizational security measures here",
    label: "Technical & organizational security measures"
  },
  {
    name: "criminalData",
    placeholder: "Select Special category or criminal data here",
    label: "Special category or criminal data"
  },
  {
    name: "AssignedTo",
    placeholder: "Select Assigned to  here",
    label: "Assigned to"
  },
]

function RopaForm({ projects, formStateRopa = {}, isUpdate, fileId, scuccessRes, selectedProject }) {
  const [formState, setFormState] = useState(formStateRopa);
  const [formdatas, setFormDatas] = useState([])
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleChangeSelect = (value, name) => {

    setFormState({ ...formState, [name]: value })

  }
  useEffect(() => { getTableData() }, [])
  useEffect(() => {
    setFormState(formStateRopa)
  }, [formStateRopa])
  const getTableData = async () => {
    if(getCookies('isAdmin') === 'admin') {
      const data = await Api.getTableData("users", localStorage.getItem("DP_PROJECT_ID"));

      if (data) {
  
        const projectData = data.data.data.results.map(item => {
          const obj = {
            value: item.id,
            label: item.name
          }
          return obj;
        })
  
        setFormDatas(projectData)
      }
    }    
  }

  const handleChange = (e, type = "text") => {
    setFormState({
      ...formState, [e.target.id]: type == "date" ? e.target.value + "T00:00:00.000Z" :
        type == "number" ? Number(e.target.value) :
          e.target.value
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const payload = {
      "project_id": formState.project_id?.value,
      "name": formState.name,
      "business_function": formState.business_function ? _.join(_.map(formState.business_function, 'value'), ', ') : null,
      "purpose": formState.purpose ? _.join(_.map(formState.purpose, 'value'), ', ') : null,
      "tenant_role": formState.tenant_role ? _.join(_.map(formState.tenant_role, 'value'), ', ') : null,
      "r2_role": formState.r2_role ? _.join(_.map(formState.r2_role, 'value'), ', ') : null,
      "individual_categories": formState.individual_categories ? _.join(_.map(formState.individual_categories, 'value'), ', ') : null,
      "personal_data_categories": formState.personal_data_categories ? _.join(_.map(formState.personal_data_categories, 'value'), ', ') : null,
      "legal_reason": formState.legal_reason ? _.join(_.map(formState.legal_reason, 'value'), ', ') : null,
      "allow_international_data_transfers": formState.allow_international_data_transfers?.value,
      "international_data_transfer_safeguards": formState.international_data_transfer_safeguards ? _.join(_.map(formState.international_data_transfer_safeguards, 'value'), ', ') : null,
      "external_recipients_with_access": formState.external_recipients_with_access ? _.join(_.map(formState.external_recipients_with_access, 'value'), ', ') : null,
      "is_retention_schedule_defined": formState.is_retention_schedule_defined?.value,
      "security_measures": formState.security_measures ? _.join(_.map(formState.security_measures, 'value'), ', ') : null,
      "criminal_data_categories": formState.criminal_data_categories ? _.join(_.map(formState.criminal_data_categories, 'value'), ', ') : null,
      "assigned_to_id": formState.assigned_to_id?.value,
      "review_date": formState.review_date,
      "data_types": formState.data_types?.value,
      "status": formState.status?.value,
      data_privacy_officer: {
        "first_name": formState.first_name,
        "last_name": formState.last_name,
        "address": formState.address,
        "city": formState.city,
        "zip_code": formState.zip_code,
        "country": formState.country,
        "phone_number": formState.phone_number,
        "email_address": formState.email_address

      }


    }
    const dataSubmit = isUpdate ? Api.updateFile(payload, "ropa", fileId) :
      await Api.createFile(payload, "ropa");
    scuccessRes(dataSubmit)
  }
  const printDocument = () => {
    setModalOpen(true);
  }
  return (
    <div className="text-start" >

      <div>
        <span className="text-3xl">
          Records of Processing Activity (ROPA) - Tenant
        </span>
        <button
          style={{ float: 'right' }}
          onClick={() => printDocument()}
          className="w-36 p-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded ml-1">Print</button>
      </div>
      <hr
        className="my-6 h-0.5 border-t-0 bg-neutral-100 opacity-100 dark:opacity-50" />


      <form onSubmit={handleSubmit}>
        <div className="text-2xl">General Purpose of the Application</div>
        <br />
        {ropaName.map(item =>
          <div className="mb-6" key={`ropname${item.name}`}>
            <textarea id={item.name} name={item.name} value={formState[item.name]}
              onChange={(e) => handleChange(e, item.type)} disabled={item.disable}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={item.placeholder} required />
          </div>
        )}
        <hr
          className="my-12 h-0.5 border-t-0 bg-neutral-100 opacity-100 dark:opacity-50" />
        <div className="text-2xl">Data Privacy Officer / Primary Contact</div>
        <br />
        <div className="grid grid-cols-2 gap-4">
          {contact.map(item =>
            <div className="mb-6" key={`cont${item.label}`}>
              <label htmlFor={item.name} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{item.label}</label>
              <input id={item.name} name={item.name} value={item.type == "date" ? formState[item.name]?.slice(0, -14) : formState[item.name]}
                onChange={(e) => handleChange(e, item.type)} disabled={item.disable}
                type={item.type ? item.type : "text"}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={item.placeholder} required />
            </div>
          )}
        </div>
        <hr
          className="my-12 h-0.5 border-t-0 bg-neutral-100 opacity-100 dark:opacity-50" />
        <div className="text-2xl">Records of Processing Activity</div>
        <br />
        <div className="grid grid-cols-3 gap-4">
          {TableBodyClass("ropa").filter(item => item.type == "select").map(item =>
            <div className="mb-6" key={`tabbody${item.name}`}>
              <label htmlFor={item.name} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{item.label}</label>
              <Select
                className="select-dd"
                value={formState[item.name]}
                onChange={(value) => handleChangeSelect(value, item.name)}
                options={item.name === "project_id" ? projects :
                  item.name == "assigned_to_id" ? formdatas : item.options}
                isMulti={item.name === "project_id" || item.isMulti === false ? false : true}
              />
            </div>
          )}
        </div>

        <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Save</button>
      </form>

      {modalOpen &&
        <PrintForm
          modalOpen={modalOpen}
          closeModal={closeModal}
          formState={formState}
          contact={contact}
          ropaName={ropaName}
          title={"Records of Processing Activity (ROPA) - Tenant"}
          type="ROPA"
          selectedProject={selectedProject}
        />
      }
    </div>
  );
}
export default RopaForm;